var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTop1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9751 2.61989C19.9339 2.50708 19.8483 2.41431 19.7368 2.36379L15.9237 0.643864C15.1127 0.375394 14.2863 0.16333 13.452 0.00833177C13.4226 0.00271111 13.3933 0 13.3645 0C13.158 0 12.973 0.139326 12.927 0.343654C12.6223 1.65426 11.4349 2.6355 9.99994 2.6355C8.56501 2.6355 7.37757 1.65433 7.07297 0.343654C7.0264 0.139326 6.84178 0 6.63537 0C6.60654 0 6.57731 0.00271111 6.54794 0.00833177C5.71363 0.16333 4.88731 0.375394 4.07493 0.643864L0.263222 2.36372C0.151015 2.41424 0.064796 2.50702 0.0256117 2.61983C-0.0149261 2.73396 -0.00761711 2.85715 0.0495013 2.9648L1.70485 6.15681C1.78234 6.3083 1.93996 6.39923 2.10671 6.39923C2.14975 6.39923 2.1934 6.39314 2.23645 6.38051L4.07499 5.84807V16.5584C4.07499 16.8016 4.27809 17 4.52768 17H15.4724C15.7213 17 15.9238 16.8016 15.9238 16.5584V5.8482L17.7636 6.38065C17.8067 6.39328 17.8503 6.39936 17.8932 6.39936C18.0597 6.39936 18.2167 6.30844 18.2952 6.15694L19.9512 2.96493C20.007 2.85722 20.015 2.73402 19.9751 2.61989Z",
    fill: "#FFB60C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop1);
export default __webpack_public_path__ + "static/media/top1.4c39484464b68ba442facb3c51644838.svg";
export { ForwardRef as ReactComponent };